import imageCompression from "browser-image-compression";

const compressImage = async (image) => {
    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true
    }
    try {
        return await imageCompression(image, options);
    } catch (error) {
        alert(error)
    }
}

export  default compressImage;